const codeRunEnv = process.env.REACT_APP_STAGE;
const runType = 'test'
//const apiBaseUrl ="http://127.0.0.1:4000"; //local
const apiBaseUrl ="https://api-dev.selyst.com"; //dev
//const apiBaseUrl ="https://api-prod.selyst.com"; //prod
const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

if (!apiBaseUrl) {
  throw new Error("❌ REACT_APP_API_URL is missing.");
}

const config = {
  apiBaseUrl,
  env: process.env.NODE_ENV,
  codeRunEnv,
  runType,
  googleApiKey,

};

console.log("✅ Loaded API URL:", apiBaseUrl);
export default config;
